import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';
import { Mention, MentionsInput } from 'react-mentions';
import './mentionTextArea.styles.less';

class MentionTextArea extends React.PureComponent {

  static propTypes = {
    automationIdPrefix: PropTypes.string,
    mentionOptions: PropTypes.array.isRequired,
    message: PropTypes.string,
    placeholder: PropTypes.string,
    onTextUpdate: PropTypes.func.isRequired,
    singleLine: PropTypes.bool,
    error: PropTypes.string,
    intl: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    hideTips: PropTypes.bool,
    autoAddedMessage: PropTypes.string,
    className: PropTypes.string
  };

  static getMentionDisplayTemplate(mention) {
    return `[${mention['display'] || 'displayName'}]`;
  }

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);

    this.state = {
      messageForDisplay: ''
    };
  }

  componentWillMount() {
    this.setMessageState(this.props.message);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.message !== this.props.message) {
      this.setMessageState(nextProps.message);
    }
  }

  /**
   *
   * @param e - The event object
   * @param newTextValue - The text in the format Hi [Member: First name]{{context.Membership.FirstName}}
   * @param newPlainTextValue - The plain text shown: Hi Member: First name
   * @param mentions the mentions used for this message
   */
  onChange(e, newTextValue, newPlainTextValue, mentions) {
    this.setState({ messageForDisplay: newTextValue });
    let messageForServer = newTextValue;
    if (mentions.length > 0) {
      this.props.mentionOptions.forEach((mention) => {
        messageForServer = messageForServer.replace(MentionTextArea.getMentionDisplayTemplate(mention), '');
      });
    }

    this.props.onTextUpdate(messageForServer);
  }

  setMessageState(message) {
    if (message) {
      let messageForDisplay = message;
      this.props.mentionOptions.forEach((mention) => {
        const mentionDisplayTemplate = MentionTextArea.getMentionDisplayTemplate(mention);
        const mentionIdTemplate = `{{${mention['id']}}}`;
        messageForDisplay = messageForDisplay.replace(mentionIdTemplate, mentionDisplayTemplate + mentionIdTemplate);
      });
      this.setState({ messageForDisplay });
    } else {
      this.setState({ messageForDisplay: '' });
    }
  }

  get placeholder() {
    if (this.props.error) {
      const errorMsg = this.props.intl.formatMessage({ id: this.props.error });
      if (this.props.placeholder) {
        return `${this.props.placeholder} - ${errorMsg}`;
      }
      return errorMsg;
    }
    return this.props.placeholder;
  }

  render() {
    const { onBlur } = this.props;
    const { formatMessage } = this.props.intl; // eslint-disable-line react/prop-types
    const clsName = classNames(this.props.className, 'mentions mention-rtl', { 'inputFieldError': this.props.error });

    return (
      <div>

        <MentionsInput
          disabled={this.props.disabled}
          value={this.state.messageForDisplay || ''}
          onChange={this.onChange}
          onBlur={onBlur}
          className={clsName}
          markup="[__display__]{{__id__}}"
          allowSpaceInQuery
          placeholder={this.placeholder}
          singleLine={this.props.singleLine}
          data-automation-id={`${this.props.automationIdPrefix}.mentionTextArea`}
        >
          <Mention
            trigger="@"
            data={this.props.mentionOptions}
          />
        </MentionsInput>
        {
          (this.props.autoAddedMessage && this.props.autoAddedMessage.length) ?
            (<p className="action-label action-note-label">
              {formatMessage({ id: 'activity.action.mentions.autoAddedMessage' }, {message: this.props.autoAddedMessage})}
            </p>)
            : null
        }
        {
          (!this.props.hideTips && true) ?
            (<p className="action-label action-note-label">
              {formatMessage({ id: 'activity.action.mentions.tip' })}
            </p>)
            : null
        }
      </div>
    );
  }
}

export default injectIntl(MentionTextArea);
